/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).on('click', '.product__thumbnail-item', function(){
	var $this = $(this);
	if($('#myVideo').length) {
		let autoplayVideo = $('#myVideo').get(0);
		if($this.is(':first-of-type')) {
			autoplayVideo.play();
		} else {
			autoplayVideo.pause();
		}
	}
});

$(document).on('click', '.show-more-discounts', function(){
	$(this).closest('.tiered-discounts').find('.tiered-discount-blocks').toggleClass('show-full');
});

$(document).on('change', '.variant-swatch__radio', function() {
	var $this = $(this),
			$img = $this.closest('.variant-swatch').find('img').attr('src');
	$this.closest('.product-form__option-selector').find('.product-form__option-value').prepend('<img class="mobileOnly" src="' + $img + '" alt="" />');
	if($this.closest('.variant-swatch-list').hasClass('show-variants')) {
		$this.closest('.variant-swatch-list').removeClass('show-variants');
	}
});

$(document).on('click', '.product-form__option-value', function(){
	$('.variant-swatch-list').toggleClass('show-variants');
});

$(document).on('click', '.boost-pfs-filter-top-sorting-wrapper', function(){
	$(this).next('.boost-pfs-filter-filter-dropdown').toggle();
});

$(document).on('click', '.product-tabs h3 a', function(){
	var $this = $(this),
	$title = $this.closest('h3');
	$target = $title.next('div');
	if($target.hasClass('tab-blog-content')) {

		if($target.hasClass('blog-slider-open')) {
			$target.removeClass('blog-slider-open');
			$title.removeClass('tab-open').addClass('tab-closed');
			} else {
			$title.addClass('tab-open').removeClass('tab-closed');
			$target.addClass('blog-slider-open');
			}
			let productHandle = $target.data('product-handle');
			if(!$target.hasClass('articles-loaded')) {
				fetch(`/products/${productHandle}?sections=product-related-articles`).then(response => response.json()).then(response => {

			let $productArticlesHtml = $(response['product-related-articles']).html();
			
			$(".tab-blog-content").html($productArticlesHtml);
			if('[data-product-articles] .article-item'.length) {
		
		 // $('[data-product-articles]').removeAttr('hidden');
		
					$('.blog-tab-slider').slick({
						slidesToShow:3,
						arrows:true,
						dots:false,
						prevArrow:'<span class="slick-arrow slick-prev"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_224_" class="st0" style="fill:#333333;" d="M250.6,325.6c2.9-2.9,4.4-6.8,4.4-10.6s-1.5-7.7-4.4-10.6L111.2,165L250.6,25.6 c5.9-5.9,5.9-15.4,0-21.2c-5.9-5.9-15.4-5.9-21.2,0l-150,150C76.6,157.2,75,161,75,165c0,4,1.6,7.8,4.4,10.6l150,150 C235.3,331.5,244.7,331.5,250.6,325.6z"/></svg></span>',
						nextArrow:'<span class="slick-arrow slick-next"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_224_" style="fill:#333333;" class="st0" d="M100.6,325.6l150-150c2.8-2.8,4.4-6.6,4.4-10.6c0-4-1.6-7.8-4.4-10.6l-150-150 c-5.9-5.9-15.4-5.9-21.2,0c-5.9,5.9-5.9,15.4,0,21.2L218.8,165L79.4,304.4c-2.9,2.9-4.4,6.8-4.4,10.6s1.5,7.7,4.4,10.6 C85.3,331.5,94.7,331.5,100.6,325.6z"/></svg></span>',
						infinite:false,
						appendArrows:$('.tab-blog-content'),
						responsive:[
							{
								breakpoint:600,
								settings:{
									slidesToShow:1
								}
							}
						]
					});
			}
			 $target.addClass('articles-loaded');
	});
			}
		 
		
	} else {
		if($target.is(':visible')) {
			$target.slideUp();
			$title.removeClass('tab-open').addClass('tab-closed');
		} else {
			$title.addClass('tab-open').removeClass('tab-closed');
			$target.slideDown();
		}
	}
});

$(document).on('click', '.show-more-color-items', function(){

		let $productGrid = $(this).closest('.collection_swatches');
		let $additionalImages = $productGrid.find('[data-additional-image]');

	Array.from($additionalImages).forEach(additionalImage => {

		let $additionalImage = $(additionalImage);
		let imageSrc = $additionalImage.find('img').data('image-src');
		$additionalImage.find('img').attr('src', imageSrc);
});
	
	$(this).remove();
});

$(document).on('click', '.color-item', function(){
	var $this = $(this),
	$image = $this.data('image'),
	$url = $this.data('url'),
	$link = $this.closest('.boost-pfs-filter-product-item').find('a'),
	$target = $this.closest('.boost-pfs-filter-product-item').find('.boost-pfs-filter-product-item-image img.boost-pfs-filter-product-item-main-image');
	$this.closest('.color-list-collection').find('.color-item-selected').removeClass('color-item-selected');
	$this.addClass('color-item-selected');
	$target.attr('src', $image).attr('srcset', $image);
	$link.attr('href', $url);
});

$(document).on('click', '.desktop-nav__item a', function(){
	$id = $(this).data('id');
	$('#' + $id).addClass('sub-menu-active');
});

$(document).on('click', '.close-sub-menu', function(){
	$('.sub-menu-active').removeClass('sub-menu-active');
	$('.third-nav-open').removeClass('third-nav-open');
	$('.third-menu').removeClass('show-third-nav');
	$('.drawer__close-button').trigger('click');
});

$(document).on('click', '.sub-menu-header', function(){
	$('.sub-menu-active').removeClass('sub-menu-active');
	$('.third-nav-open').removeClass('third-nav-open');
	$('.third-menu').removeClass('show-third-nav');
});

$(document).on('mouseover', '.sub-menu-nav > li > a', function(){
	var $this = $(this),
	$parent = $this.closest('li'),
	$target = '#' + $this.data('id');
	if(!$parent.hasClass('third-nav-open')) {
		$('.third-nav-open').removeClass('third-nav-open');
		$parent.addClass('third-nav-open');
		$('.third-menu').removeClass('show-third-nav');
		$($target).addClass('show-third-nav');
	}
});

$(document).on('click', '.drawer__overlay', function(){
	$('.sub-menu-active').removeClass('sub-menu-active');
	$('.show-third-nav').removeClass('show-third-nav');
	$('.third-nav-open').removeClass('third-nav-open');
});

$(document).on('click', '.show-full-collection', function(){
	$(this).closest('.collection-mobile').toggleClass('show-all');
});

$(document).on('click', '.secondary-header-nav a', function(){
	var $this = $(this),
	$dataId = $this.attr('href');
	if($dataId.startsWith('#', 0)) {
		$dataId = $dataId.replace('#', '');
		$('#desktop-menu-drawer a[data-id="' + $dataId + '"]').trigger('click');
		setTimeout(function(){
			$('.header-menu-toggle[aria-controls="desktop-menu-drawer"]').trigger('click');
		}, 400);
		return false;
	}
});

$(document).on('click', 'img.icon-arrow-down', function(){
	$(this).closest('li').find('ul').slideToggle();
	$(this).closest('.sublinks').toggleClass('mobile-accordion-open');
	return false;
});

$(document).on('click', '.faq-accordion-item > a', function(){
	$(this).closest('.faq-accordion-item').find('p').slideToggle();
	$(this).toggleClass('faq-accordion-open');
	return false;
});

$(document).on('click', '.mc-note-toggle', function(){
	var $target = $(this).attr('data-target');
	$( '#' + $target).addClass('open-order-note');
});

$(document).on('click', '.form__submit--closer, .custom-overlay', function(){
	var $target = $(this).closest('#mini-cart-note'),
	$val = $target.find('textarea').val();
	if($val == '' || $val == ' ') {
		$('.mc-note-toggle').addClass('no-note');
	} else {
		$('.mc-note-toggle').removeClass('no-note');
	}
	$target.removeClass('open-order-note');
});

$(document).ready(function(){
	closeAccordionsMobile();
	arrowSizeCarousel();
});

$(window).on('resize', function(){
	arrowSizeCarousel();
});

function closeAccordionsMobile() {
	if($('.product-tabs').length) {
		var $windowWidth = $(window).width();
		if($windowWidth <= 600) {
			$('.product-tabs:not(.product-tabs-details) .tab-open').next('div').hide();
			$('.product-tabs:not(.product-tabs-details) .tab-open').removeClass('tab-open');
		}
	}
}

function arrowSizeCarousel() {
	if($('.collection-carousel').length) {
		var $height = $('.collection-carousel .boost-pfs-filter-product-item-image-link').outerHeight();
		$('.collection-carousel .slick-arrow').css('height', $height + 'px');
		/*console.log($height);*/
	}
}

$(document).on('click', '.scroll-to-reviews', function(){
	var $id = $($(this).data('scroll-to')),
	$offset = $id.offset().top;
	$('html, body').animate({
		'scrollTop':$offset
	});
	return false;
})

/*
$(document).on('change input', '.boost-pfs-search-box', function(e){
	var $inputfield = $(this);
	var $interval;
	var $collInterval;
	var $pageInterval;
	if($inputfield.is(':focus')) {
		$('.boost-pfs-search-suggestion').html('');
	}
	var $html = '',
	$collection = '',
	$pages = '';
	if(!$interval) {
		$interval = setInterval(function(){
			if($html == '') {
				$('.boost-pfs-search-suggestion .boost-pfs-search-suggestion-group[data-group="products"] ul li').each(function(){
					var $this = $(this);
					if(!$this.hasClass('boost-pfs-search-suggestion-header')) {
						var $url = $this.find('a').attr('href'),
						$img = $this.find('img').attr('src'),
						$title = $this.find('.boost-pfs-search-suggestion-product-title').html(),
						$price = $this.find('.boost-pfs-search-suggestion-product-price span.boost-pfs-search-suggestion-product-regular-price').html();
						$html += '<li class="boost-search__product-item line-item line-item--centered"><a href="' + $url + '" class="line-item__content-wrapper"><span class="line-item__image-wrapper"><img class="line-item__image" src="' + $img + '" width="1000" height="1000"></span><div class="line-item__info"><div class="product-item-meta"><span class="product-item-meta__title text--small">' + $title + '</span><div class="product-item-meta__price-list-container text--small"><div class="price-list"><span class="price">' + $price + '</span></div></div></div></div><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></a></li>';
					}
				});
				if($('.boost-pfs-search-suggestion-groups-pro').length && $('.boost-pfs-search-suggestion-groups-pro').is(':empty')) {
					$html = '<li>No products found</li>';
				}
				$('#boost-search-products ul').html($html);
				$('.boost-search-results').removeAttr('style');
				if($inputfield.val() == '' || $inputfield.val() == ' ') {
					$('.boost-search-results').css('opacity', '0');
				}
			} else {
				clearInterval($interval);
			}
		}, 100);
	}
	if(!$collInterval) {
		$collInterval = setInterval(function(){
			if($collection == '') {
				$('.boost-pfs-search-suggestion .boost-pfs-search-suggestion-group[data-group="collections"] ul li').each(function(){
					var $this = $(this);
					if(!$this.hasClass('boost-pfs-search-suggestion-header')) {
						var $url = $this.find('a').attr('href'),
						$name = $this.find('a').text();
						$collection += '<li class="boost-search__linklist-item predictive-search__linklist-item"><a class="boost-search__linklist-link predictive-search__linklist-link" href="' + $url + '">' + $name + '<svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></a></li>';
					}
				});
				$('#boost-search-collections ul').html($collection);
			} else {
				clearInterval($collInterval);
			}
		}, 100);
	}
	if(!$pageInterval) {
		$pageInterval = setInterval(function(){
			if($pages == '') {
				$('.boost-pfs-search-suggestion .boost-pfs-search-suggestion-group[data-group="pages"] ul li').each(function(){
					var $this = $(this);
					if(!$this.hasClass('boost-pfs-search-suggestion-header')) {
						var $url = $this.find('a').attr('href'),
						$name = $this.find('a').text();
						$pages += '<li class="boost-search__linklist-item predictive-search__linklist-item"><a class="boost-search__linklist-link predictive-search__linklist-link" href="' + $url + '">' + $name + '<svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path></svg></a></li>';
					}
				});
				$('#boost-search-articles ul').html($pages);
			} else {
				clearInterval($pageInterval);
			}
		}, 100);
	}
});
*/

$(document).on('click', '.footer__item-title', function(){
	$(this).closest('.footer__item').toggleClass('show-content');
});

$(function(){

	if($(".template-product").length) {
	 const carouselProductsInterval = setInterval(function() {
		const $carouselProducts = $('.carousel-products-mobile');
		if ($carouselProducts.length) {
				clearInterval(carouselProductsInterval);
					$carouselProducts.slick({
			slidesToShow:4.5,
		infinite:false,
				prevArrow:"<span class='slick-prev'><img src=//cdn.shopify.com/s/files/1/0558/3725/t/285/assets/left-arrow-icon.png?v=24086386832803755061662542137 alt='' /></span>",
				nextArrow:"<span class='slick-next'><img src=//cdn.shopify.com/s/files/1/0558/3725/t/285/assets/right-arrow-icon.png?v=32950710964850516781662542137 alt='' /></span>",
				responsive: [
								{
						breakpoint: 999,
						settings: {
							slidesToShow: 3.7
						}
					},
						{
								breakpoint: 768,
							 settings: {
							slidesToShow: 1.7
						}
						}
				]
		});

			
		$(window).on('resize', function() {
				$carouselProducts.slick('resize');
		});
		}
}, 250)
	}
});

$(document).on('click', '.cart-notification__view-cart', function(e) {

		e.preventDefault();
		$('[aria-controls="mini-cart"]:visible')[0].click();
	 $(this).closest('cart-notification').attr('hidden', '');
});

function handleProductInfoTabs() {

	if(window.matchMedia('(min-width: 768px)').matches) {

		Array.from($('[data-open-desktop]')).forEach(tabTitle => {
			$(tabTitle).addClass('tab-open');
			$(tabTitle).closest('.product-main-content').find('[data-content]').show();
});
	} else {
				Array.from($('[data-open-mobile]')).forEach(tabTitle => {
			$(tabTitle).addClass('tab-open');
			$(tabTitle).closest('.product-main-content').find('[data-content]').show();
});
	}
}
 function callSlickSliderOnVariantUpsell() {
	$('.variant-upsell-wrapper .threads_zippers_main .special-offer-products').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	infinite:false,
	autoplay: false,
	dots: true,
	mobileFirst: true,
	arrows: true,
	dots: false,
	prevArrow: '<button class="slick-prev slick-arrow"><svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 27" width="15" height="27"><defs><image  width="15" height="27" id="img1" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAbCAMAAACUTyX1AAAAAXNSR0IB2cksfwAAAK5QTFRFra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tKvhoIwAAADp0Uk5TAIOQA/+23sN3tL2IsIW3f8G4vouEwIKvslnu013nFWPgEVjlD2ESV+YQXt0UYNlb4wna8OrN3xyal06dH/YAAACUSURBVHicXc1XEsIwDEVRBUTvvRM6BJLQ2/43hh8zchT771xbFpGXyZI6HnNOO8/MBeWiMZfSA8xlFSoIVRVqCHUVGghNd6Tlvmir0HFfdBF6KvQRBioMERKOxoYTyyluZ3OhDy6WwhW43gi3/9udcA8eAuERPIXCCIztV2fwck3xZvfS3fBhFxE9mV9hQnp/voHiD//TCRr+MU6EAAAAAElFTkSuQmCC"/></defs><style></style><use  href="#img1" x="0" y="0"/></svg></button>',
	nextArrow: '<button class="slick-next slick-arrow"><svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 27" width="15" height="27"><defs><image  width="15" height="27" id="img1" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAbCAMAAACUTyX1AAAAAXNSR0IB2cksfwAAAK5QTFRFra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tKvhoIwAAADp0Uk5TAIOQA/+23sN3tL2IsIW3f8G4vouEwIKvslnu013nFWPgEVjlD2ESV+YQXt0UYNlb4wna8OrN3xyal06dH/YAAACUSURBVHicXc1XEsIwDEVRBUTvvRM6BJLQ2/43hh8zchT771xbFpGXyZI6HnNOO8/MBeWiMZfSA8xlFSoIVRVqCHUVGghNd6Tlvmir0HFfdBF6KvQRBioMERKOxoYTyyluZ3OhDy6WwhW43gi3/9udcA8eAuERPIXCCIztV2fwck3xZvfS3fBhFxE9mV9hQnp/voHiD//TCRr+MU6EAAAAAElFTkSuQmCC"/></defs><style></style><use  href="#img1" x="0" y="0"/></svg></button>',                 
	responsive: [
	{
	breakpoint: 601,
	settings: 'unslick'
	}
	]
	});
	}
$(function(){
	handleProductInfoTabs();
	 
		if($('.variant-upsell-wrapper .threads_zippers_main .special-offer-products').length
			 && $('.variant-upsell-wrapper .threads_zippers_main .special-offer-products .line-item.special-offer-item')
			&& $('.variant-upsell-wrapper .threads_zippers_main .special-offer-products .line-item.special-offer-item').length > 3) {
		callSlickSliderOnVariantUpsell();
	$(".variant-upsell-wrapper .threads_zippers_main .special-offer-products").addClass("maximum_item");
						
				} else {
				$(".variant-upsell-wrapper .threads_zippers_main .special-offer-products").addClass("minimum_item");
				}
});

$(window).resize(function(){
 handleProductInfoTabs();
});
const fetchFavouriteProducts = async () => {

	let sectionName = "customer-favourite-products";
	let response = await fetch(`${window.Shopify.routes.root}?sections=${sectionName}`);
	response = await response.json();
	let responseHTML = new DOMParser().parseFromString(response[sectionName], 'text/html');
	let sectionInnerHTML = responseHTML.querySelector(`#shopify-section-${sectionName}`).innerHTML;
	sectionInnerHTML = sectionInnerHTML.trim();
	let favoriteProducts = JSON.parse(JSON.stringify(sectionInnerHTML));
	favoriteProducts = typeof favoriteProducts == "object" ? favoriteProducts : JSON.parse(favoriteProducts);
	return favoriteProducts;
};

const addFavElementLoader = favElement => {
	favElement.querySelector(".loader-button__loader").removeAttribute("hidden");
	favElement.classList.add("is-loading");
}
const removeFavElementLoader = favElement => {
		favElement.querySelector(".loader-button__loader").setAttribute("hidden", true);
		favElement.classList.remove("is-loading");
}
const toggleFavouriteElement = (favElement, remove) => {
	
	let favouriteText = favElement.querySelector(".favourite-text");
	if(remove) {
	
	favElement.classList.remove('added-favourite');
	favouriteText.innerHTML = favouriteText?.dataset.favouriteText;
	
	} else {
	
	favElement.classList.add('added-favourite');
	favElement.classList.add('animate-favourite');
	setTimeout(function(){
		favElement.classList.remove('animate-favourite');
	}, 2000)
	favouriteText.innerHTML = favouriteText?.dataset.favouriteFilledText;
	
	}
};
const updateFavourite = async (favElement) => {

		let variantId = favElement.dataset.variantId;
		let isCustomer = !!(favElement.dataset.loginCustomer && favElement.dataset.loginCustomer !== "null");
		let customerRedirect = favElement.dataset.loginRedirect;

	 favElement.classList.add("updating-favourite");
		if(!isCustomer) {
			window.location.href = customerRedirect;
		}

		 variantId = parseInt(variantId, 10);
		 let removeFavouriteItem = !!favElement.classList.contains('added-favourite');
	 
		let favouriteProductsUrl = `${window.Shopify.routes.root}apps/dreamcart-api/favourite?variant=${variantId}`;
		favouriteProductsUrl = removeFavouriteItem ? `${favouriteProductsUrl}&remove=true`: favouriteProductsUrl;

		try {

				addFavElementLoader(favElement);
 
				let response = await fetch(favouriteProductsUrl).then(response => response.json());
				
				if(response.success){

					toggleFavouriteElement(favElement, removeFavouriteItem);
					removeFavElementLoader(favElement);

					if(favElement.closest(".fav-products-item")) {
						window.location.reload();
					}
					
			} else {
					console.log(response);
					removeFavElementLoader(favElement);
			}
		} catch(e){
			removeFavElementLoader(favElement);
			console.log(e);
		}
		 finally {
			 favElement.classList.remove("updating-favourite");
		 }
}

 document.addEventListener('variant:changed', async function(event) {
	
		let variant = event.detail.variant;
		let favoriteProductResponse = await fetchFavouriteProducts();
		let favoriteProducts = favoriteProductResponse.favourite_products || [];
		let isCustomer = !!favoriteProductResponse.customerId;

		if(isCustomer){
		let favElement = document.querySelector(".add-to-favourite");
		favElement.dataset.variantId = variant.id;
		let isFavouriteVariant = favoriteProducts.filter(favoriteProduct => favoriteProduct.id == variant.id);
		let removeFavouriteItem = !(!!isFavouriteVariant.length);
		toggleFavouriteElement(favElement, removeFavouriteItem);
			
		}
	
	
 });
const handleFavouriteProducts = async () => {

	let favoriteProductResponse = await fetchFavouriteProducts();
	let favoriteProducts = favoriteProductResponse.favourite_products || [];
	let isCustomer = !!favoriteProductResponse.customerId;
	
	if(favoriteProducts.length && isCustomer) {
			favoriteProducts.forEach(favProduct => {
			
				var favElement = document.querySelector(`.add-to-favourite[data-variant-id="${favProduct.id}"]`);
			 
				if(favElement) {
					
					favElement.classList.add('added-favourite');
					favElement.querySelector(".favourite-text").innerHTML = favElement.querySelector(".favourite-text")?.dataset.favouriteFilledText;
				}
			});
	}
};
document.addEventListener("DOMContentLoaded", function() {
handleFavouriteProducts();
});

function handleCompareProductAdd($this, $event, productId) {
$event.stopPropagation();
	$event.preventDefault();
	console.log(productId, $this);
}

$(document).on('click', '.product_group_tooltip_icon', function(){
	var $this = $(this),
	$windowWidth = $(window).outerWidth();
	if($windowWidth < 601) {
		$(this).closest('.product_group_tooltip_container').toggleClass('tooltip_open');
	}
});

$(document).on('click', '.product_group_tooltip_close', function(){
	$(this).closest('.product_group_tooltip_container').removeClass('tooltip_open');
});

$(document).on('click', '.button--color-card', function(){
	let $this = $(this);
	let $form = $this.closest('.product-form').find('form');
	var $btnHtml = $this.html();
	var variant_id = $this.data('variant-id');
	var quantity = $this.data('quantity');
	var serialized = "id=" + variant_id + "&quantity=" + quantity;
	$.ajax({
		url: `${window.themeVariables.routes.cartAddUrl}.js?sections=mini-cart`,
		dataType: 'json',
		type: 'post',
		data: serialized,
		success: function(responseJson) {
			$('#added-to-cart-msg').fadeIn().delay(1000).fadeOut();
			$this.html('Added');
			window.dispatchEvent(
				new CustomEvent('Added Swatch', {
					detail:  responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
				})
			);
			if(window.themeVariables.settings.cartType === "drawer" || window.themeVariables.settings.cartType === "message") {
				fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
					const cartContent = await response2.json();
					document.querySelectorAll('.header__cart-count.bubble-count').forEach(bubbleCount => {
						if(cartContent && cartContent.items.length){
							bubbleCount.innerHTML = cartContent.items.length;
						}
					
					});
					document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
						bubbles: true,
						detail: {
							cart: cartContent
						}
					}));
					cartContent["sections"] = responseJson["sections"];
					let openMiniCart = window.themeVariables.settings.cartType === "page";
					document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
						bubbles: true,
						detail: {
							cart: cartContent,
							openMiniCart: openMiniCart
						}
					}));
				});
			}
			if (window.themeVariables.settings.cartType === "message") {
				$form[0].dispatchEvent(new CustomEvent("cart-notification:show", {
					bubbles: true,
					cancelable: true,
					detail: {
						status: "success"
					}
				}));
			}
			setTimeout(function(){
				$this.html($btnHtml)}, 
			1000);
		},
		error: function(XMLHttpRequest) {
			$('.cart-error-message').remove();
			var $addToCartForm = $this.closest('form');
			var $addToCartBtn = $addToCartForm.find('.add_to_cart');
			var response = eval('(' + XMLHttpRequest.responseText + ')');
			response = response.description;		
			if(response.includes('Swatch')) {
				let productNameParts = response.replace("The product", "").replace("is already sold out.", "");
				productNameParts = productNameParts.trim();
				let productName = productNameParts.split('-')[0];
				productName = productName.trim();
				response = `The product 'SWATCH: ${productName}' is already sold out.`;
			}
			if (window.themeVariables.settings.cartType === "message") {
				document.dispatchEvent(new CustomEvent("cart-notification:show", {
					bubbles: true,
					cancelable: true,
					detail: {
						status: "error",
						error: response
					}
				}));
			} else {
				$('.cart-error-message').remove();
				var $errorMessage = '<p style="margin-top: 10px;" class="cart-error-message warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
				$addToCartForm.after($errorMessage);
				setTimeout(function(){
					$('.cart-error-message').remove();
				}, 5000);
			}
		}
	});
});

$(document).on('change input', '.gift-box-checkbox', function(){
	var $this = $(this);
	if($this.is(':checked')) {
		$('.gift-card-recipient__fields').show();
	} else {
		$('.gift-card-recipient__fields').hide();
	}
});